(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("axios"), require("@zibu/common-base"));
	else if(typeof define === 'function' && define.amd)
		define(["axios", "@zibu/common-base"], factory);
	else if(typeof exports === 'object')
		exports["Common"] = factory(require("axios"), require("@zibu/common-base"));
	else
		root["Common"] = factory(root["axios"], root["@zibu/common-base"]);
})(typeof window !== 'undefined' ? window : this, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__4__) {
return 